export default __webpack_public_path__ + "static/media/ic-menu.89bcd96d.svg";